import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
    history: createWebHistory('/'),
    routes: [
        {
            path: '/public/contract/:clinicId/:contractId',
            name: 'Donation Contracts',
            component: () => import('@/modules/donation-contracts/DonationContracts.vue'),
        },
        {
            path: '/public/paperwork/:clinicId',
            name: 'Paperwork',
            component: () => import('@/modules/paperwork/PublicPaperwork.vue'),
        },
        {
            path: '/public/communication/:id',
            name: 'Communication Preferences',
            component: () => import('@/modules/communication-preferences/CommunicationPreferences.vue'),
        },
        {
            path: '/public/billing/:token',
            name: 'Billing',
            component: () => import('@/modules/billing/Overview.vue'),
        },
        {
            path: '/public/billing/:token/appointments/:requestId',
            name: 'Billing Appointments',
            component: () => import('@/modules/billing/Appointments.vue'),
        },
        {
            path: '/public/signup/:id?',
            name: 'Leads',
            component: () => import('@/modules/lead/Lead.vue'),
        }
    ],
})

export default router
